export * from './reset-confirm.view';
